import React, { useEffect, useState, useCallback} from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import "./PayrollReconciliationPage.css";

const PayrollReconciliationPage = () => {
    const { id: businessId } = useParams();
    const [year, setYear] = useState(new Date().getFullYear());
    const [payrollRecords, setPayrollRecords] = useState([]);
    const [matchMap, setMatchMap] = useState({});
    const [loading, setLoading] = useState(true);

    
    // hoisted + memoized fetcher
const fetchPayrollAndMatches = useCallback(async (showLoader = false) => {
  if (showLoader) setLoading(true);
  try {
    const { data } = await api.post(`/payroll/reconciliation/${businessId}`, { year });
    setPayrollRecords(data.records);

    const results = await Promise.all(
      (data.records || []).map((record) =>
        api.post(`/reconciliation/candidates`, { payroll_id: record.id })
      )
    );
    const matches = {};
    (data.records || []).forEach((record, i) => {
      matches[record.id] = results[i]?.data?.candidates || [];
    });
    setMatchMap(matches);
  } catch (err) {
    console.error("Error loading reconciliation data:", err);
    alert("Failed to load reconciliation data.");
  } finally {
    if (showLoader) setLoading(false);
  }
}, [businessId, year]); // ✅ proper deps



useEffect(() => {
   fetchPayrollAndMatches(true);
 }, [fetchPayrollAndMatches]); 



    const handleReconcile = async (payrollId, transactionId) => {
        try {
            await api.post(`/reconciliation/match`, {
                payroll_id: payrollId,
                transaction_id: transactionId
            });
            await fetchPayrollAndMatches();
        } catch (error) {
            console.error("Reconciliation error:", error);
            alert("Reconciliation failed.");
        }
    };

    const handleUnlink = async (payrollId) => {
  try {
    await api.post(`/reconciliation/unmatch`, { payroll_id: payrollId });
    await fetchPayrollAndMatches();
  } catch (err) {
    console.error("Unlink error:", err);
    alert("Failed to unlink transaction.");
  }
};


    return (
        <div className="employees-page-container">
            <h3 className="page-title-employees">Payroll Reconciliation</h3>

            <div className="emp-buttons-payroll">
                <label>
                    Year:{" "}
                    <input
                        type="number"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        className="year-input"
                    />
                </label>
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <table className="employees-table-payroll">
                        <thead>
                            <tr>
                                <th>Check Date</th>
                                <th>Check No.</th>
                                <th>Employee Name</th>
                                <th>Net Pay</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payrollRecords.length > 0 ? (
                                payrollRecords.map((record) => (
                                    <React.Fragment key={record.id}>
                                        <tr>
                                            <td>{new Date(record.check_date).toLocaleDateString()}</td>
                                            <td>{record.check_no}</td>
                                            <td>{record.NAME}</td>
                                            <td>${parseFloat(record.NET_PAY).toFixed(2)}</td>
                                            <td>{record.is_reconciled ? "✅" : "❌"}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="5">
                                                {matchMap[record.id]?.length > 0 ? (
                                                    <div className="match-list">
                                                        {record.is_reconciled ? (
                                                            <>
                                                                <strong>Reconciled Transaction:</strong>
                                                                <ul>
                                                                    {matchMap[record.id].map(tx => (
                                                                        <li key={tx.id}>
                                                                          {new Date(tx.date).toLocaleDateString()} - {tx.name} - ${parseFloat(tx.amount).toFixed(2)} 
                                                                          <button
                                                                            className="unlink-button"
                                                                            onClick={() => handleUnlink(record.id)}
                                                                        >
                                                                            Unlink
                                                                        </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <strong>Candidate Transactions:</strong>
                                                                <ul>
                                                                    {matchMap[record.id].map(tx => (
                                                                        <li key={tx.id}>
                                                                            {new Date(tx.date).toLocaleDateString()} - {tx.name} - ${parseFloat(tx.amount).toFixed(2)}
                                                                            <button
                                                                                className="match-button"
                                                                                onClick={() => handleReconcile(record.id, tx.id)}
                                                                            >
                                                                                Match
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="match-list">
                                                        <p><em>No matching transactions found.</em></p>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="no-employees">
                                        No payroll records found for {year}.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};

export default PayrollReconciliationPage;



// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";
// //import "./PayrollReconciliationPage.css";

// const PayrollReconciliationPage = () => {
//     const { id: businessId } = useParams();
//     const [year, setYear] = useState(new Date().getFullYear());
//     const [payrollRecords, setPayrollRecords] = useState([]);
//     const [totals, setTotals] = useState({});
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchPayrollData = async () => {
//             try {
//                 const { data } = await api.post(`/payroll/reconciliation/${businessId}`, { year });
//                 setPayrollRecords(data.records);
//                 setTotals(data.totals);
//             } catch (error) {
//                 console.error("Error fetching payroll reconciliation data:", error);
//                 alert("Failed to load reconciliation data.");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchPayrollData();
//     }, [businessId, year]);

//     return (
//         <div className="employees-page-container">
//             <h3 className="page-title-employees">Payroll Reconciliation</h3>

//             <div className="emp-buttons">
//                 <label>
//                     Year:{" "}
//                     <input
//                         type="number"
//                         value={year}
//                         onChange={(e) => setYear(e.target.value)}
//                         className="year-input"
//                     />
//                 </label>
//             </div>

//             {loading ? (
//                 <p>Loading...</p>
//             ) : (
//                 <>
//                     <table className="employees-table">
//                         <thead>
//                             <tr>
//                                 <th>Check Date</th>
//                                 <th>Employee Name</th>
//                                 <th>Net Pay</th>
//                                 <th>Reconciled</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {payrollRecords.length > 0 ? (
//                                 payrollRecords.map((record) => (
//                                     <tr key={record.id}>
//                                         <td>{new Date(record.check_date).toLocaleDateString()}</td>
//                                         <td>{record.NAME}</td>
//                                         <td>${parseFloat(record.NET_PAY).toFixed(2)}</td>
//                                         <td>{record.is_reconciled ? "✅" : "❌"}</td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="4" className="no-employees">
//                                         No payroll records found for {year}.
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>

//                     <div className="totals-summary">
//                         <p><strong>Total Gross Pay:</strong> ${parseFloat(totals.totalGrossPay || 0).toFixed(2)}</p>
//                         <p><strong>Total Net Pay:</strong> ${parseFloat(totals.totalNetPay || 0).toFixed(2)}</p>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default PayrollReconciliationPage;
